import { useDialogState } from "../../../hooks/use-dialog-state/UseDialogState";
import { UICustomizationPresetEditorDialogState } from "./UICustomizationPresetEditorDialog";

export function useUICustomizationPresetEditorDialogState(): UICustomizationPresetEditorDialogState {
    return useDialogState();
}
